import { render, staticRenderFns } from "./BabyNames.vue?vue&type=template&id=1d3f8ab9&"
import script from "./BabyNames.vue?vue&type=script&lang=js&"
export * from "./BabyNames.vue?vue&type=script&lang=js&"
import style0 from "./BabyNames.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports